import { DateTimeFormatter } from '~/@mid_ui/datetime-formatter/DateTimeFormatter'
import type { IMyAmbassadorData } from '~/@api/generated-api-types-ambassador/Api'
import { InfoField } from '~/@mid_ui/info-field/InfoField'

type Props = {
  myAmbassador: IMyAmbassadorData
}

export function MyAmbassadorDetails({ myAmbassador }: Props) {
  const { ambassador, claimedAt } = myAmbassador

  return (
    <div className="flex flex-col lg:flex-row gap-5 lg:gap-10">
      <InfoField size="lg" label="Referencia" value={ambassador.reference} />
      <InfoField size="lg" label="Tel. Číslo" value={ambassador.phone ?? '—'} />
      <InfoField
        size="lg"
        label="Vytvorené"
        value={<DateTimeFormatter value={claimedAt} />}
      />
    </div>
  )
}
